import { render, staticRenderFns } from "./ProblemFilterFormItem.vue?vue&type=template&id=43875ff0&scoped=true"
import script from "./ProblemFilterFormItem.vue?vue&type=script&lang=js"
export * from "./ProblemFilterFormItem.vue?vue&type=script&lang=js"
import style0 from "./ProblemFilterFormItem.vue?vue&type=style&index=0&id=43875ff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43875ff0",
  null
  
)

export default component.exports